<template>
    <div v-if="isDisplay">
        <p-custom-image
            :style="{'order': formStyle[formStyle.template_active].formCustomImage.positionIndex}"
            v-model="formStyle[formStyle.template_active].formCustomImage"
            :time="time"
            :isDisplay="isDisplayComponent('formCustomImage')"
        ></p-custom-image>
        <p-progress-bar
            :style="{'order': formStyle[formStyle.template_active].formProgressBar.positionIndex}"
            v-model="formStyle[formStyle.template_active].formProgressBar"
            :percent="percent"
            :isDisplay="isDisplayComponent('formProgressBar')"
        ></p-progress-bar>
        <p-text
            :style="{'order': formStyle[formStyle.template_active].formText.positionIndex}"
            v-model="formStyle[formStyle.template_active].formText"
            :isDisplay="isDisplayComponent('formText')"
        ></p-text>
        <p-percentage-counter
            :style="{'order': formStyle[formStyle.template_active].formPercentage.positionIndex}"
            v-model="formStyle[formStyle.template_active].formPercentage"
            :percent="percent"
            :isDisplay="isDisplayComponent('formPercentage')"
        ></p-percentage-counter>
        <p-loading-icon
            :style="{'order': formStyle[formStyle.template_active].formLoadingIcon.positionIndex}"
            v-model="formStyle[formStyle.template_active].formLoadingIcon"
            :isDisplay="isDisplayComponent('formLoadingIcon')"
        ></p-loading-icon>
    </div>
</template>
<script>
import PCustomImage from '../Preview/PCustomImage'
import PLoadingIcon from '../Preview/PLoadingIcon'
import PProgressBar from '../Preview/PProgressBar'
import PText from '../Preview/PText'
import PPercentageCounter from '../Preview/PPercentageCounter'
export default {
    name: 'Preview',
    props: {
        value: {
            type: Object,
            required: true
        },
        isDisplay: {
            type: Boolean,
            default: false
        },
        time: {
            type: Number,
            required: true
        },
        percent: {
            type: Number,
            default: 0
        }
    },
    components: {
        PCustomImage,
        PLoadingIcon,
        PProgressBar,
        PText,
        PPercentageCounter
    },
    computed: {
        formStyle: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    },
    methods: {
        isDisplayComponent(component) {
            return this.formStyle[this.formStyle.template_active].componentsDisplay.includes(component)
        }
    }
}
</script>